import { Navigate, Route, Routes } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import HomePage from "../pages/HomePage";
import SaveTheDatePage from "../pages/SaveTheDatePage";
import AdminLoginPage from "../pages/admin/AdminLoginPage";
import AdminChangePasswordPage from "../pages/admin/AdminChangePasswordPage";
import AdminDashboardPage from "../pages/admin/AdminDashboardPage";
import AdminGuestsPage from "../pages/admin/AdminGuestsPage";
import AdminEmailTestPage from "../pages/admin/AdminEmailTestPage";
import { RequireAdmin } from "./guards";

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/save-the-date" element={<SaveTheDatePage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin/change-password"
          element={
            <RequireAdmin>
              <AdminChangePasswordPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/guests"
          element={
            <RequireAdmin>
              <AdminGuestsPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/email-test"
          element={
            <RequireAdmin>
              <AdminEmailTestPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboardPage />
            </RequireAdmin>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
